import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>
        <p className="text-xl mt-20">
        A Developer curious to make something new and attractive using appropriate technology, tools and techniques.
As a personable, dedicated performer who demonstrates communication, and teamwork to ensure quality and time
for project completion.
{/* <p>
  Hii, 
  my name is Smruti ranjan Basantia and Currently I am porsuing my Bachelors of Computer application From Bhadrak Autonomous College Bhadrak , Odisha 
  
</p> */}
        </p>
        ● Learn technologies like Networking , Operating system , DBMS, CO and do hands-on about many new
programming languages and tools with guidance from various industry experience professors. With into
Web development
<p>
● Career Objectives To pursue a challenging career and a part of a progressive organization that gives a
scope to enhance my knowledge and utilization of my skills towards the growth of the organization
</p>
         
      </div>
    </div>
  );
};

export default About;
